import * as fromServiceGroupCategories from './service-group-categories.actions';
import {
  initialState,
  serviceGroupCategoriesAdapter,
  ServiceGroupCategoriesState
} from './service-group-categories.interfaces';

export function reducer(
  state: ServiceGroupCategoriesState = initialState,
  action: fromServiceGroupCategories.ServiceGroupCategoriesAction
): ServiceGroupCategoriesState {
  switch (action.type) {
    case fromServiceGroupCategories.GET_SERVICE_GROUP_CATEGORIES_FROM_SERVER_SUCCESS: {
      return {
        ...serviceGroupCategoriesAdapter.addMany(action.payload.serviceGroupCategories, state)
      };
    }

    default: {
      return state;
    }
  }
}
